import { findIndex, pathOr, propEq, propOr } from 'ramda';

export const handleChangeDiscount = (
  form,
  value,
  beneficiaryIndex,
  supplementaryCover,
  discountOptions,
  textInformations,
  index
) => {
  const pricingsForm = form.watch(`offer.packs.${beneficiaryIndex}.pricings`);

  const selectedOptionIndex = findIndex(propEq('value', value))(discountOptions) || 0;
  if (!supplementaryCover) {
    pricingsForm.forEach((pricing, index) => {
      if (
        propOr(false, 'supplementaryCover', pricing) &&
        propOr(false, 'isLinkedToDiscountProduct', pricing)
      ) {
        const textInformations = pathOr([], ['waiverRequests', 0, 'textInformations'], pricing);

        form.setValue(
          `offer.packs.${beneficiaryIndex}.pricings.${index}.waiverRequests.0.code`,
          value
        );

        form.setValue(
          `offer.packs.${beneficiaryIndex}.pricings.${index}.waiverRequests.0.textInformation`,
          textInformations[selectedOptionIndex]
        );
      }
    });
  }

  form.setValue(
    `offer.packs.${beneficiaryIndex}.pricings.${index}.waiverRequests.0.textInformation`,
    textInformations[selectedOptionIndex]
  );
};
